import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  log(...args: unknown[]): void { if (!environment.production) console.log(...args); }
  error(...args: unknown[]): void { if (!environment.production) console.error(...args); }
  warn(...args: unknown[]): void { if (!environment.production) console.warn(...args); }
}
